import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancelledPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-p2p-surface to-white flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl border border-p2p-border/50 p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-6 bg-red-100 rounded-full flex items-center justify-center">
            <XCircle className="w-8 h-8 text-red-500" />
          </div>
          
          <h1 className="font-manrope text-2xl font-bold text-p2p-teal mb-2">
            Payment Cancelled
          </h1>
          
          <p className="text-p2p-muted mb-6">
            Your payment was cancelled. No charges were made to your account.
          </p>
          
          <div className="bg-p2p-surface/50 rounded-xl p-4 mb-6">
            <p className="text-sm text-p2p-muted">
              If you experienced any issues during checkout, please try again or contact support.
            </p>
          </div>

          <div className="space-y-3">
            <Button
              onClick={() => navigate("/settings")}
              className="btn-primary w-full"
              data-testid="try-again-btn"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Try Again
            </Button>
            
            <Button
              variant="outline"
              onClick={() => navigate("/calendar")}
              className="w-full"
              data-testid="back-to-calendar-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Calendar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
